import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import EnterLayout from '../../components/layout/EnterLayout';
import Alert from '../../components/common/Alert';
import { sendPermTokenRequest, sendUpdateSettingsRequest } from '../../utils/api/accountApi';
import { getParsedParams } from '../../utils/consts/params';

const SubscriptionConfirmedRoute = () => {
  useEffect(() => {
    const params = getParsedParams();

    if (params.PERMANENT_TOKEN) {
      // login user and set his newsletter option to `true`, so it can be unchecked in profile
      void sendPermTokenRequest(params.PERMANENT_TOKEN).then(() => sendUpdateSettingsRequest(true));
    }
  }, []);

  const intl = useIntl();

  return (
    <EnterLayout verticalPaddings={{ top: 70, bottom: 80 }}>
      <Alert
        icon="success"
        title={intl.formatMessage({
          id: 'newsletterSubConfirmed.title',
          defaultMessage: 'Thank you!',
          description: 'Title of the page',
        })}
        description={intl.formatMessage({
          id: 'newsletterSubConfirmed.text',
          defaultMessage: 'Subscription successfully confirmed',
          description: 'Main message of the page',
        })}
      />
    </EnterLayout>
  );
};

export default SubscriptionConfirmedRoute;
